// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.header {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  margin: 0 0 5px 0;
  height: -moz-fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
}

.subheader {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: normal;
  margin: 0;
  min-height: 18pt;
  display: flex;
  align-items: center;
}

.caption {
  font-size: 13px;
  font-weight: normal;
  margin: 0;
  min-height: 18pt;
  display: flex;
  align-items: center;
}

.bottom-text-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-top: 5px solid #1B3E78;
  margin-top: 10px;
  padding-top: 5px;
}
.bottom-text-container p {
  font-family: "Arial";
  font-size: 11px;
  color: rgb(158, 158, 158);
  line-height: 15px;
  margin: 0;
}

.main-container {
  overflow: hidden;
  padding: 0 10px 0 10px;
  height: 100%;
}

.main-container-iframe {
  overflow: hidden;
  padding: 0 10px 0 10px;
}

.plot {
  overflow: hidden;
  padding: 0 20px 0 0;
}

app-loader {
  vertical-align: center;
}

@media (max-width: 767px) {
  .main-container-iframe {
    width: 90vw;
  }
  .bottom-text-container {
    padding: 5px 10px 0;
  }
}
/** Colors variables */
.sb-default .sb-wrapper {
  --sb-color: #fff;
  --sb-background: var(--button-color);
  --sb-border-radius: 4px;
  --sb-overflow: hidden;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text {
  --sb-text-padding: 0 1em 0 0;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text .sb-text {
  filter: none;
}

/** Colors variables */
.sb-circles-dark .sb-wrapper, .sb-circles-light .sb-wrapper {
  --sb-color: #fff;
  --sb-background: transparent;
  --sb-min-width: fit-content;
  --sb-height: fit-content;
  --sb-icon-size: 1.4em;
}
.sb-circles-dark .sb-wrapper:active .sb-icon, .sb-circles-light .sb-wrapper:active .sb-icon {
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 5px 22px 4px rgba(0, 0, 0, 0.12);
}
.sb-circles-dark .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-icon {
  background-color: var(--button-color);
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 2.5em;
  min-height: 2.5em;
  border-radius: 50%;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-text, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
  font-size: 0.8em;
  margin-top: 5px;
  border-radius: 1em;
  width: 100%;
  height: 1.8em;
  line-height: 1.8em;
  padding: 0;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-content, .sb-circles-light .sb-wrapper .sb-content {
  align-items: center;
  flex-direction: column;
}

.sb-circles-dark .sb-wrapper .sb-icon {
  background-color: var(--button-color);
}
.sb-circles-dark .sb-wrapper .sb-text {
  color: var(--button-color);
}

.sb-circles-light .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
}
.sb-circles-light .sb-wrapper .sb-icon {
  background: radial-gradient(ellipse farthest-corner at center, white 30%, #f2f2f2 100%);
}

/* You can add global styles to this file, and also import other style files */
body, html {
  height: 100vh;
  margin: 0;
}

body {
  font-family: Arial, sans-serif;
  height: 100vh;
  background-color: #fff; /* Background color for the top half */
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
}

body::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: #fff;
  z-index: -1; /* Ensure the gradient is behind other content */
}

/* Old palette
\$theme-main: #B05995;
\$theme-contrast: #3792BF;
\$theme-1: #282B59;
\$theme-2: #D683DD;
\$theme-3: #27567A;
\$theme-4: #44DDC4;
\$theme-5: #3336AE;
\$theme-6: #18C43D;
*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 48;
}

p {
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  color: #2D2D2A;
}

html, body {
  height: 100%;
}

body {
  margin: 0;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.generic-button, .generic-button-alt {
  color: white;
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding for button size */
  margin-right: 10px;
  cursor: pointer; /* Pointer on hover */
  transition: background-color 0.3s; /* Smooth transition on hover */
}
.generic-button p, .generic-button-alt p {
  color: white;
  margin: 0;
}

.generic-button {
  background-color: #1B3E78; /* Button background color */
  border: 2px solid #1B3E78; /* No border */
}

.generic-button-alt {
  background-color: #0CAD99; /* Button background color */
  border: 2px solid #0CAD99; /* No border */
}

.generic-button:hover {
  background-color: #fff; /* Change color on hover */
  color: #1B3E78;
}
.generic-button:hover p {
  color: #1B3E78;
}

.generic-button-alt:hover {
  background-color: #fff; /* Change color on hover */
  color: #0CAD99;
}
.generic-button-alt:hover p {
  color: #0CAD99;
}

.generic-button:disabled, .generic-button-alt:disabled {
  background-color: #e7e7e7;
  border-color: #e7e7e7;
  cursor: not-allowed;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 3px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.general-container {
  display: flex;
  flex-direction: column;
}

.category-container-1, .category-container-2, .category-container-3, .category-container-4 {
  width: 100%;
  height: 100%;
  display: grid;
  box-sizing: border-box;
}

.category-container-1 {
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
}

.category-container-2 {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
}

.category-container-3 {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
}

.category-container-3 .category:nth-child(2) {
  grid-row: span 2;
}

/*.category-container-3 .category:nth-child(2){
    grid-row: span 2;   
}*/
.category-container-4 {
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 0.9fr 1.1fr;
}

.product:hover {
  border-color: #0CAD99;
  cursor: pointer;
}

.category {
  padding-right: 2%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  position: relative;
}
.category h1 {
  font-size: 12px;
  margin: 2px;
}

.title {
  display: flex;
  justify-content: space-between;
}
.title h1 {
  font-size: 15px;
  margin: 2px;
}

.products {
  display: flex;
  max-width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
}

.logo-container {
  display: flex;
  margin: 5px 5px 5px 10px;
  min-width: 30px;
  justify-content: flex-start;
}

.logo {
  object-fit: cover;
  max-width: 30px;
  max-height: 17px;
}

.product {
  display: flex;
  background: white;
  width: 260px;
  border-radius: 10px;
  border: 1px solid #BDBDBD;
  justify-content: space-between;
  margin-bottom: 2px;
}

.product-content {
  display: flex;
  align-items: center;
}
.product-content p {
  font-size: 10px;
  align-self: flex-start;
  margin: 5px;
}

a {
  display: flex;
  text-decoration: none;
  align-items: center;
  margin: 2px 0 2px 0;
}

.share {
  display: flex;
  align-items: center;
  margin-right: 5px;
}
.share p {
  padding: 0;
  margin: 0 0 0 2px;
  font-size: 10px;
}

.footer .bottom-text-container {
  display: flex;
  justify-content: space-between;
}
.footer .source, .footer .chartid {
  font-family: "Arial";
  font-size: 11px;
  color: rgb(158, 158, 158);
  line-height: 15px;
  margin: 0;
}

.products-container-1 {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 325px;
  column-gap: 10px;
}
.products-container-1 .logo-container {
  width: 80px;
}
.products-container-1 .logo {
  object-fit: cover;
  max-width: 80px;
  max-height: 25px;
}
.products-container-1 p {
  font-size: 13px;
  align-self: flex-start;
  margin: 5px;
}
.products-container-1 .product {
  width: 100%;
}
.products-container-1 .products {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.products-container-2 {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 325px;
  column-gap: 10px;
}
.products-container-2 .product {
  width: 45%;
}

.products-container-3 {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  height: 325px;
  column-gap: 10px;
}
.products-container-3 .product {
  width: 31%;
}
.products-container-3 p {
  font-size: 9px;
}`, "",{"version":3,"sources":["webpack://./src/theme/fonts.scss","webpack://./src/app/shared/toolbox/charts/product-list/product-list.component.scss","webpack://./src/theme/variables.scss","webpack://./src/app/shared/toolbox/charts/chartsCommonStyles.scss","webpack://./node_modules/ngx-sharebuttons/themes/variables.scss","webpack://./node_modules/ngx-sharebuttons/themes/default.scss","webpack://./node_modules/ngx-sharebuttons/themes/circles.scss","webpack://./src/styles.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACCF;ADEA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ACAF;ADGA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACDF;ADIA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ACFF;ADKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACHF;ADMA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ACJF;ADOA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ACLF;ADQA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACNF;ADSA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ACPF;ADUA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACRF;ADWA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ACTF;ADYA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ACVF;ADaA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ACXF;ADcA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ACZF;ADeA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ACbF;ADgBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ACdF;ADiBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ACfF;ADkBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AChBF;ACpGA;;;;;uBAAA;ACNA;EACI,yCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EAEA,iBAAA;EACA,wBAAA;EAAA,mBAAA;EAEA,aAAA;EACA,mBAAA;AFgHJ;;AE3GA;EACI,yCAAA;EACA,eAAA;EACA,mBAAA;EAEA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AF6GJ;;AE1GA;EACI,eAAA;EACA,mBAAA;EAEA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AF4GJ;;AEzGA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;AF4GJ;AEzGI;EACI,oBAAA;EAAqB,eAAA;EACrB,yBAAA;EACA,iBAAA;EACA,SAAA;AF4GR;;AEvGA;EAEI,gBAAA;EACA,sBAAA;EACA,YAAA;AFyGJ;;AErGA;EACI,gBAAA;EACA,sBAAA;AFwGJ;;AEpGA;EAEI,gBAAA;EACA,mBAAA;AFsGJ;;AElGA;EACI,sBAAA;AFqGJ;;AElGA;EASI;IACI,WAAA;EF6FN;EE1FA;IACE,mBAAA;EF4FF;AACF;AG5LA,sBAAA;ACEA;EACE,gBAAA;EACA,oCAAA;EACA,uBAAA;EACA,qBAAA;AJ6LF;AI3LE;EACE,4BAAA;AJ6LJ;AI3LI;EACE,YAAA;AJ6LN;;AGzMA,sBAAA;AEME;EACE,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qBAAA;ALuMJ;AKpMM;EACE,sHAAA;ALsMR;AKlMI;EACE,qCAAA;EACA,iHAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2GAAA;ALoMN;AKjMI;EACE,0BAAA;EACA,gBA3BS;EA4BT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,2GAAA;ALmMN;AKhMI;EACE,mBAAA;EACA,sBAAA;ALkMN;;AK3LE;EACE,qCAAA;AL8LJ;AK3LE;EACE,0BAAA;AL6LJ;;AKvLE;EACE,0BAAA;AL0LJ;AKvLE;EACE,uFAAA;ALyLJ;;AMtPA,8EAAA;AAEA;EACA,aAAA;EAEA,SAAA;ANuPA;;AMpPA;EACI,8BAAA;EACA,aAAA;EACA,sBAAA,EAAA,sCAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;ANuPJ;;AMnPA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EAGA,WAAA,EAAA,gDAAA;ANoPJ;;AM/OA;;;;;;;;;CAAA;AA0CA;EAEI,eAAA;EACA,kEACI;ANgNR;;AM1MA;EACI,yCAAA;EACA,mBAAA;EACA,cAxDS;ANqQb;;AMxMA;EAAa,YAAA;AN4Mb;;AM3MA;EAAO,SAAA;EAAW,iDAAA;ANgNlB;;AM7MA;EACE,YAAA;EACA,kBAAA,EAAA,oBAAA;EACE,kBAAA,EAAA,4BAAA;EACA,kBAAA;EAGA,eAAA,EAAA,qBAAA;EACA,iCAAA,EAAA,+BAAA;AN8MJ;AM5MI;EACI,YAAA;EACA,SAAA;AN8MR;;AM3MA;EACE,yBArEW,EAqEoB,4BAAA;EAC/B,yBAAA,EAAA,cAAA;AN8MF;;AM3MA;EACE,yBA7Da,EA6DoB,4BAAA;EACjC,yBAAA,EAAA,cAAA;AN8MF;;AM3MA;EACI,sBAAA,EAAA,0BAAA;EACA,cAhFS;AN8Rb;AM5MI;EACI,cAnFK;ANiSb;;AM1MA;EACE,sBAAA,EAAA,0BAAA;EACA,cA5Ea;ANyRf;AM3ME;EACE,cA/EW;AN4Rf;;AMzMA;EACI,yBA/Ec;EAgFd,qBAhFc;EAiFd,mBAAA;AN4MJ;;AA7VA;EACI,wBAAA;EACA,UAAA;AAgWJ;;AA7VE;EACE,kBAAA;EACA,oCAAA;EACA,4CAAA;AAgWJ;;AA7VE;EACE,aAAA;EACA,sBAAA;AAgWJ;;AA5VA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AA+VJ;;AA3VA;EACI,0BAAA;EACA,uBAAA;AA8VJ;;AA3VA;EACI,8BAAA;EACA,uBAAA;AA8VJ;;AA3VA;EACI,8BAAA;EACA,2BAAA;AA8VJ;;AA5VA;EACI,gBAAA;AA+VJ;;AA7VA;;EAAA;AAIA;EACI,8BAAA;EACA,+BAAA;AA+VJ;;AA3VA;EACI,qBMNa;ENOb,eAAA;AA8VJ;;AAxVA;EAMI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AAsVJ;AA/VI;EACI,eAAA;EACA,WAAA;AAiWR;;AAvVA;EACI,aAAA;EACA,8BAAA;AA0VJ;AAzVI;EACI,eAAA;EACA,WAAA;AA2VR;;AAtVA;EACI,aAAA;EACA,eAAA;EACA,eAAA;EACA,8BAAA;AAyVJ;;AAvVA;EACI,aAAA;EACA,wBAAA;EACA,eAAA;EACA,2BAAA;AA0VJ;;AAtVA;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;AAyVJ;;AAtVA;EACI,aAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACD,yBAAA;EACA,8BAAA;EAEC,kBAAA;AAwVJ;;AApVA;EACI,aAAA;EACA,mBAAA;AAuVJ;AAtVI;EACI,eAAA;EACA,sBAAA;EACA,WAAA;AAwVR;;AAnVA;EACI,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;AAsVJ;;AAnVA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;AAsVJ;AArVI;EACI,UAAA;EACA,iBAAA;EACA,eAAA;AAuVR;;AAlVI;EACI,aAAA;EACA,8BAAA;AAqVR;AAnVI;EACI,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,SAAA;AAqVR;;AAhVA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AAmVJ;AAlVI;EACI,WAAA;AAoVR;AAlVI;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;AAoVR;AAlVI;EACI,eAAA;EACA,sBAAA;EACA,WAAA;AAoVR;AAjVI;EACI,WAAA;AAmVR;AAjVI;EAEI,aAAA;EACA,sBAAA;EACA,eAAA;AAkVR;;AA9UA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AAiVJ;AA/UI;EACI,UAAA;AAiVR;;AA5UA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AA+UJ;AA7UI;EACI,UAAA;AA+UR;AA9UI;EACI,cAAA;AAgVR","sourcesContent":["@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import '../chartsCommonStyles.scss';\n@import '../../../../../styles.scss';\n\n::-webkit-scrollbar {\n    -webkit-appearance: none;\n    width: 3px;\n  }\n  \n  ::-webkit-scrollbar-thumb {\n    border-radius: 4px;\n    background-color: rgba(0, 0, 0, .5);\n    box-shadow: 0 0 1px rgba(255, 255, 255, .5);\n  }\n\n  .general-container{\n    display:flex;\n    flex-direction: column;\n   \n  }\n\n.category-container-1,.category-container-2,  .category-container-3, .category-container-4 {\n    width:100%;\n    height:100%;\n    display: grid;\n    box-sizing: border-box;\n\n}\n\n.category-container-1{\n    grid-template-columns: 1fr;\n    grid-template-rows: 1fr;\n}\n\n.category-container-2{\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr;\n}\n\n.category-container-3{\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr 1fr;\n}\n.category-container-3 .category:nth-child(2){\n    grid-row: span 2;   \n}\n/*.category-container-3 .category:nth-child(2){\n    grid-row: span 2;   \n}*/\n\n.category-container-4{\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 0.9fr 1.1fr;\n\n}\n\n.product:hover {\n    border-color: $theme-contrast;\n    cursor:pointer;\n}\n\n\n\n\n.category{\n    h1{\n        font-size:12px;\n        margin:2px\n    }\n  \n    padding-right:2%;\n    display: flex;\n    flex-direction: column;\n    overflow:auto;\n    position:relative;\n\n}\n.title{\n    display: flex;\n    justify-content: space-between;\n    h1{\n        font-size:15px;\n        margin:2px\n    }\n\n}\n\n.products{\n    display:flex;\n    max-width: 100%;\n    flex-wrap:wrap;\n    justify-content: space-between;\n}\n.logo-container{\n    display:flex;\n    margin:5px 5px 5px 10px;\n    min-width:30px;\n    justify-content: flex-start;\n}\n\n\n.logo{\n    object-fit: cover;\n    max-width:30px;\n    max-height:17px;\n\n}\n.product{\n    display:flex;\n    background:white;\n    width:260px;\n    border-radius:10px;\n   border:1px solid $theme-3;\n   justify-content: space-between;\n    //box-shadow: 0 2px 4px 0 $theme-3;\n    margin-bottom:2px;\n\n   \n}\n.product-content{\n    display:flex;\n    align-items: center;\n    p{\n        font-size: 10px;\n        align-self: flex-start;\n        margin:5px\n    }\n   \n}\n\na{\n    display:flex;\n    text-decoration: none;\n    align-items: center;\n    margin:2px 0 2px 0;\n}\n\n.share{\n    display:flex;\n    align-items: center;\n    margin-right:5px;\n    p{\n        padding:0;\n        margin:0  0 0 2px;\n        font-size:10px;\n    }\n}\n.footer{\n \n    .bottom-text-container{\n        display:flex;\n        justify-content: space-between;\n    }\n    .source, .chartid{\n        font-family: \"Arial\";\n        font-size: 11px;\n        color: rgb(158, 158, 158);\n        line-height: 15px;\n        margin: 0;\n    }\n}\n\n\n.products-container-1{\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    height: 325px;\n    column-gap: 10px; \n    .logo-container{\n        width:80px;\n    }\n    .logo{\n        object-fit: cover;\n        max-width:80px;\n        max-height:25px;\n    }\n    p{\n        font-size: 13px;\n        align-self: flex-start;\n        margin:5px\n    }\n   \n    .product{\n        width:100%;\n    }\n    .products{\n    \n        display: flex;\n        flex-direction: column;\n        flex-wrap: wrap;\n    }\n}\n\n.products-container-2{\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    height: 325px;\n    column-gap: 10px;\n\n    .product{\n        width:45%;\n    }\n \n}\n\n.products-container-3{\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    height: 325px;\n    column-gap: 10px; \n\n    .product{\n        width:31%;}\n    p{\n        font-size:9px\n    }\n}\n\n   \n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n","@import \"variables\";\n.header {\n    font-family:Arial, Helvetica, sans-serif;\n    font-size:clamp(16px, 18px, 24px);\n    font-weight:bold;\n    text-align: left;\n\n    margin: 0 0 5px 0;\n    height:fit-content;\n    //min-height:42pt;\n    display:flex;\n    align-items: center;\n\n\n}\n\n.subheader {\n    font-family:Arial, Helvetica, sans-serif;\n    font-size:clamp(14px,16px,22px);\n    font-weight:normal;\n\n    margin:0;\n    min-height: 18pt;\n    display:flex;\n    align-items: center;\n}\n\n.caption {\n    font-size:clamp(11px, 13px, 18px);\n    font-weight:normal;\n\n    margin:0;\n    min-height: 18pt;\n    display:flex;\n    align-items: center;\n}\n\n.bottom-text-container {\n    display:flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    border-top: 5px solid $dark-text;\n    margin-top: 10px;\n    padding-top: 5px;\n    //padding: 5px 5px 0 5px;\n\n    p { //source and chartid together\n        font-family: 'Arial';font-size: clamp(10px, 11px, 15px);\n        color: rgb(158, 158, 158);\n        line-height:15px;\n        margin:0\n    }\n\n}\n\n.main-container {\n\n    overflow: hidden;\n    padding:0 10px 0 10px;\n    height: 100%;\n\n}\n\n.main-container-iframe {\n    overflow: hidden;\n    padding:0 10px 0 10px;\n\n}\n\n.plot {\n    //height:300px;\n    overflow:hidden;\n    padding: 0 20px 0 0;\n\n}\n\napp-loader {\n    vertical-align: center;\n}\n\n@media (max-width: 767px) {\n    .main-container {\n\n        // min-width:350px;\n        //width:380px;\n        //max-width: 75vw;\n\n    }\n\n    .main-container-iframe{\n        width: 90vw;\n    }\n\n  .bottom-text-container {\n    padding: 5px 10px 0;\n  }\n}\n","/** Colors variables */\r\n\r\n$sb-primary: #2E4057 !default;\r\n$sb-accent: #fff !default;\r\n$sb-facebook: #4267B2 !default;\r\n$sb-twitter: #00acee !default;\r\n$sb-google: #db4437 !default;\r\n$sb-mix: #ff8226 !default;\r\n$sb-linkedin: #006fa6 !default;\r\n$sb-pinterest: #bd081c !default;\r\n$sb-reddit: #ff4006 !default;\r\n$sb-tumblr: #36465d !default;\r\n$sb-whatsapp: #25d366 !default;\r\n$sb-messenger: #0080FF !default;\r\n$sb-telegram: #0088cc !default;\r\n$sb-xing: #006567 !default;\r\n$sb-email: #FF961C !default;\r\n$sb-viber: #665ca7 !default;\r\n$sb-vk: #4C75A3 !default;\r\n$sb-copy: #607D8B !default;\r\n$sb-print: #765AA2 !default;\r\n$sb-sms: #20c16c !default;\r\n$sb-gray: #a5a5a5 !default;\r\n$sb-expand: #FF6651 !default;\r\n$sb-line: #00b900 !default;\r\n\r\n$sb-buttons: (\r\n  facebook: $sb-facebook,\r\n  twitter: $sb-twitter,\r\n  google: $sb-google,\r\n  mix: $sb-mix,\r\n  line: $sb-line,\r\n  linkedin: $sb-linkedin,\r\n  pinterest: $sb-pinterest,\r\n  reddit: $sb-reddit,\r\n  tumblr: $sb-tumblr,\r\n  whatsapp: $sb-whatsapp,\r\n  messenger: $sb-messenger,\r\n  telegram: $sb-telegram,\r\n  xing: $sb-xing,\r\n  sms: $sb-sms,\r\n  email: $sb-email,\r\n  viber: $sb-viber,\r\n  vk: $sb-vk,\r\n  copy: $sb-copy,\r\n  print: $sb-print,\r\n  expand: $sb-expand\r\n) !default;\r\n","@import \"variables\";\r\n\r\n.sb-default .sb-wrapper {\r\n  --sb-color: #{$sb-accent};\r\n  --sb-background: var(--button-color);\r\n  --sb-border-radius: 4px;\r\n  --sb-overflow: hidden;\r\n\r\n  &.sb-show-icon.sb-show-text {\r\n    --sb-text-padding: 0 1em 0 0;\r\n\r\n    .sb-text {\r\n      filter: none;\r\n    }\r\n  }\r\n}\r\n","@import \"variables\";\r\n\r\n$sb-text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);\r\n$sb-text-size: 0.8em;\r\n\r\n.sb-circles-dark, .sb-circles-light {\r\n  .sb-wrapper {\r\n    --sb-color: #{$sb-accent};\r\n    --sb-background: transparent;\r\n    --sb-min-width: fit-content;\r\n    --sb-height: fit-content;\r\n    --sb-icon-size: 1.4em;\r\n\r\n    &:active {\r\n      .sb-icon {\r\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, .2), 0 12px 17px 2px rgba(0, 0, 0, .14), 0 5px 22px 4px rgba(0, 0, 0, .12);\r\n      }\r\n    }\r\n\r\n    .sb-icon {\r\n      background-color: var(--button-color);\r\n      box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);\r\n      width: 2.5em;\r\n      min-height: 2.5em;\r\n      border-radius: 50%;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-text {\r\n      color: var(--button-color);\r\n      font-size: $sb-text-size;\r\n      margin-top: 5px;\r\n      border-radius: 1em;\r\n      width: 100%;\r\n      height: 1.8em;\r\n      line-height: 1.8em;\r\n      padding: 0;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-content {\r\n      align-items: center;\r\n      flex-direction: column;\r\n    }\r\n  }\r\n}\r\n\r\n.sb-circles-dark .sb-wrapper {\r\n\r\n  .sb-icon {\r\n    background-color: var(--button-color);\r\n  }\r\n\r\n  .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n}\r\n\r\n.sb-circles-light .sb-wrapper {\r\n\r\n  .sb-icon, .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n\r\n  .sb-icon {\r\n    background: radial-gradient(ellipse farthest-corner at center, white 30%, darken(white, 5%) 100%);\r\n  }\r\n}\r\n","\n@import \"../node_modules/ngx-sharebuttons/themes/default.scss\";\n@import \"../node_modules/ngx-sharebuttons/themes/circles.scss\";\n\n/* You can add global styles to this file, and also import other style files */\n\nbody, html {\nheight: 100vh;\n// width: 100vh;\nmargin: 0;\n}\n\nbody {\n    font-family: Arial, sans-serif;\n    height: 100vh;\n    background-color: #fff; /* Background color for the top half */\n    position: relative;\n    display: block;\n    justify-content: center;\n    align-items: center;\n    }\n\n\nbody::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 50%;\n    background: #fff;\n\n\n    z-index: -1; /* Ensure the gradient is behind other content */\n}\n\n\n$theme-back: #2D2D2A;\n/* Old palette\n$theme-main: #B05995;\n$theme-contrast: #3792BF;\n$theme-1: #282B59;\n$theme-2: #D683DD;\n$theme-3: #27567A;\n$theme-4: #44DDC4;\n$theme-5: #3336AE;\n$theme-6: #18C43D;\n*/\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$theme-primary: #3792BF;\n$theme-secondary: #1B3E78;\n$theme-color3: #AACCFF;\n$theme-color4: #BDBDBD;\n$theme-color5: #7D7979;\n$theme-accent: #0CAD99;\n$text-gray:#787c95;\n$theme-red:#d9534f;\n\n$theme-back-light: #4c4c47;\n$theme-lightgray: #e7e7e7;\n$theme-gray-text: #787476;\n\n$theme-table-header: #f6f6f6;\n$theme-table-body:#f8f8f8;\n$theme-source:#9E9E9E;\n\n\n$value-chain-1: #44DDC4;\n$value-chain-2: \"\";\n$value-chain-3: \"\";\n$value-chain-4: \"\";\n\n.material-symbols-outlined {\n\n    cursor: pointer;\n    font-variation-settings:\n        'FILL' 0,\n        'wght' 400,\n        'GRAD' 0,\n        'opsz' 48;\n}\n\np {\n    font-family:Arial, Helvetica, sans-serif;\n    text-align: justify;\n    color: $theme-back;\n}\n\n\n\nhtml, body { height: 100%; }\nbody { margin: 0; font-family: Roboto, \"Helvetica Neue\", sans-serif; }\n\n\n.generic-button, .generic-button-alt {\n  color: white;\n  border-radius: 5px;   /* Rounded corners */\n    padding: 10px 20px;    /* Padding for button size */\n    margin-right: 10px;\n\n    // font-size: 16px;       /* Font size */\n    cursor: pointer;       /* Pointer on hover */\n    transition: background-color 0.3s; /* Smooth transition on hover */\n\n    p {\n        color:white;\n        margin:0;\n    }\n}\n.generic-button {\n  background-color: $theme-main; /* Button background color */\n  border: 2px solid $theme-main;      /* No border */\n}\n\n.generic-button-alt {\n  background-color: $theme-accent; /* Button background color */\n  border: 2px solid $theme-accent;      /* No border */\n}\n\n.generic-button:hover {\n    background-color: #fff; /* Change color on hover */\n    color: $theme-main;\n\n    p {\n        color: $theme-main\n    }\n}\n\n.generic-button-alt:hover {\n  background-color: #fff; /* Change color on hover */\n  color: $theme-accent;\n\n  p {\n    color: $theme-accent\n  }\n}\n\n.generic-button:disabled, .generic-button-alt:disabled {\n    background-color: $theme-lightgray;\n    border-color: $theme-lightgray;\n    cursor:not-allowed;\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
